import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { Fade } from "@progress/kendo-react-animation";
import { Button } from "@progress/kendo-react-buttons";
import { SvgIcon } from "@progress/kendo-react-common";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Checkbox, FlatColorPicker, TextBox } from "@progress/kendo-react-inputs";
import { useLocalization } from "@progress/kendo-react-intl";
import { Avatar } from "@progress/kendo-react-layout";
import { NotificationGroup, Notification } from "@progress/kendo-react-notification";
import { copyIcon, plusIcon, saveIcon, trashIcon } from "@progress/kendo-svg-icons";
import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { AccessToken } from "../../../config/AccessToken";
import { loadingPanel } from "../../LoadingPanel";

export const RegistryGroups = () => {

    const localizationService = useLocalization();
    let languageId = localStorage.getItem('languageId');
    const SERVER_URL = process.env.REACT_APP_SERVER_URL;
    const [instance, accessTokenRequest] = AccessToken();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<any>(false);
    const [errorMessage, setErrorMessage] = useState<any>('');

    const [valueColor, setValueColor] = useState<any>('#ffffff');
    const [groupsList, setGroupsList] = useState<any>([]);
    const [jobsList, setJobsList] = useState<any>([]);

    const [toggleColorPicker, setToggleColorPicker] = useState<boolean>(false);

    const [groupInfo, setGroupInfo] = useState<any>([{ 'id': '', 'name': '', 'description': '', 'color': '', 'job': '', 'type': '' }]);


    const [groupName, setGroupName] = useState<any>('');
    const [groupDescription, setGroupDescription] = useState<any>('');
    const [groupTypeName, setGroupTypeName] = useState<any>('');
    const [groupTypeId, setGroupTypeId] = useState<any>('');

    const [jobsSelected, setJobsSelected] = useState<any>([]);

    const [updateGroup, setUpdateGroup] = useState<boolean>(false);

    const [messageDeletedGroup, setMessageDeletedGroup] = useState<boolean>(false);
    const [messageSavedGroup, setMessageSavedGroup] = useState<boolean>(false);
    const [messageClonedGroup, setMessageClonedGroup] = useState<boolean>(false);
    const [messageUpdatedGroup, setMessageUpdatedGroup] = useState<boolean>(false);

    const groupsTypeList = {
        "data": [
            {
                "id": 0,
                "name": 'Generic'
            },
            {
                "id": 1,
                "name": 'Pointer'
            },
            {
                "id": 2,
                "name": 'Forklift'
            },
            {
                "id": 3,
                "name": 'Truck'
            },
            {
                "id": 4,
                "name": 'Car'
            },
            {
                "id": 5,
                "name": 'Man'
            },
            {
                "id": 6,
                "name": 'Named'
            }
        ]
    }

    useEffect(() => {
        getGroupList(true, true);
        getJobList(true);
    }, []);

    const getGroupList = async (flag: boolean, needsJobs: boolean) => {

        setLoading(true);

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/group/list?enabled=${flag}&needsJobs=${needsJobs}`, { headers })
                .then((res) => {
                    const data = res?.data?.data
                    setGroupsList(data);
                    setLoading(false);
                })
                .catch((error) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    setLoading(false);
                });
        }
        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                    setLoading(false);
                });
        }
    }

    const getJobList = async (flag: boolean) => {

        //setLoading(true);
        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/job/list?enabled=${flag}`, { headers })
                .then((res) => {
                    const data = res?.data?.data

                    let jobList: any = []
                    data.forEach((job: any) => {
                        jobList.push(job)
                    });
                    setJobsList(jobList);
                    //setLoading(false);
                })
                .catch((error) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    setLoading(false);
                });
        }

        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                });
                setLoading(false);
        }
    };

    const rgba2hex = (rgba: any) => {
        return "#" + rgba.replace(/^rgba?\(|\s+|\)$/g, '') // Get's rgba / rgb string values
            .split(',') // splits them at ","
            .filter((string: any, index: any) => index !== 3)
            .map((string: any) => parseFloat(string)) // Converts them to numbers
            .map((number: any, index: any) => index === 3 ? Math.round(number * 255) : number) // Converts alpha to 255 number
            .map((number: any) => number.toString(16)) // Converts numbers to hex
            .map((string: any) => string.length === 1 ? "0" + string : string) // Adds 0 when length of one number is 1
            .join("")
    }

    const handleChangeColor = useCallback((event: any) => {
        let color:any = rgba2hex(event.value);
        setValueColor(color);
    }, []);

    const showColorPicker = () => {
        setToggleColorPicker(!toggleColorPicker);
    }

    const handleChangeGroupName = (event: any) => {
        let currentName:any = event.target.value
        setGroupName(currentName)

        if(currentName == ''){
            setGroupName([]);
        }else{
            let newGroup: any = [];
            newGroup.push({ 'id': groupInfo[0]?.id, 'name': currentName, 'description': groupInfo[0]?.description, 'color': groupInfo[0]?.color, 'job': groupInfo[0]?.job, 'type': groupInfo[0]?.type })
            setGroupInfo(newGroup);
        }
    }

    const handleChangeGroupDescription = (event: any) => {
        let currentDescription:any = event.target.value
        setGroupDescription(currentDescription)
        if(currentDescription == ''){
            setGroupInfo([]);
        }else{
            let newGroup: any = [];
            newGroup.push({ 'id': groupInfo[0].id, 'name': groupInfo[0].name, 'description': currentDescription, 'color': groupInfo[0].color, 'job': groupInfo[0].job, 'type': groupInfo[0].type })
            setGroupInfo(newGroup);
        }
    }

    const handleChangeJob = (ev: any, jobId: any) => {

        let currentJobs: any = (groupInfo[0]?.job != "" && groupInfo[0]?.job != undefined) ? groupInfo[0]?.job : []

        let checked: any = ev?.target?.element?.checked ?? ev;

        jobsList?.forEach((job: any, idx: any) => {
            if (jobId === job.id) {
                if (checked) {
                    job.checked = true
                    currentJobs?.push(job)
                } else {
                    job.checked = false
                    currentJobs?.splice(idx, 1)
                }
            }
        })
        setJobsSelected([...currentJobs])

        let newGroup: any = [];
        newGroup.push({ 'id': groupInfo[0].id, 'name': groupInfo[0].name, 'description': groupInfo[0].description, 'color': groupInfo[0].color, 'job': currentJobs, 'type': groupInfo[0].type })
        setGroupInfo(newGroup);

    }

    const handleChangeGroupType = (event: any) => {
        setGroupTypeName(event.target.value);
        //setGroupTypeId(event.target.index);

        let newGroup: any = [];
        newGroup.push({ 'id': groupInfo[0].id, 'name': groupInfo[0].name, 'description': groupInfo[0].description, 'color': groupInfo[0].color, 'job': groupInfo[0].job, 'type': event.target.value })
        setGroupInfo(newGroup);
    }

    const getSelectedGroup = (group: any) => {
        
        setGroupInfo([{ 'id': group.id, 'name': group.name, 'description': group.description, 'color': group.color, 'job': group.jobs, 'type': group.groupType }]);
        
        setGroupName(group.name)
        setGroupDescription(group.description)
        setJobsSelected(group.jobs)
        setValueColor(group.color);
        setGroupTypeName(group.groupType);

        jobsList?.forEach((item: any) => {
            item.checked = false
        });

        if (group?.jobs?.length > 0) {
            group?.jobs?.forEach((job: any) => {
                if (jobsList.find((e: any) => e.id === job.id)) {
                    jobsList.forEach((item: any) => {
                        if (item.id == job.id) {
                            item.checked = true
                        }
                    });
                }
            });
        } else {
            jobsList.forEach((item: any) => {
                item.checked = false
            });
        }

        setUpdateGroup(true)
    }

    const updateSelectedGroup = async (groupId: any, groupName: any, groupDescription: any, groupColor: any, jobList: any, groupType: any) => {

        setLoading(true);

        let jobListId: any = []
        jobList?.forEach((job: any) => {
            jobListId.push(job.id)
        });

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            const params = {
                name: groupName,
                description: groupDescription,
                color: groupColor,
                type: groupType,
                jobList: jobListId
            }

            try {
                await axios.put(`${SERVER_URL}/group/${groupId}`, params, { headers })
                setGroupName('')
                handleChangeGroupName({ target: { value: '' } })
                setGroupDescription('')
                handleChangeGroupDescription({ target: { value: '' } })
                handleChangeColor({ value: '#ffffff' })
                setValueColor('#ffffff')
                handleChangeGroupType({ target: { value: '' } })
                setUpdateGroup(false)
                getGroupList(true, true);
            } catch (error: any) {
                setError(error);
                setErrorMessage(error?.response?.data?.errorMessage)
                if (error) {
                    setTimeout(() => {
                        setError(false);
                    }, 3000);
                }
                setLoading(false)
            }
        }

        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken)
            })
        }
        
        setMessageUpdatedGroup(true);
        if (!messageUpdatedGroup) {
            setTimeout(() => {
                setMessageUpdatedGroup(false);
            }, 3000);
        }
    }

    const saveNewGroup = async (currGroupName: any, currValueColor: any) => {

        setLoading(true);

        let jobListId: any = []
        jobsSelected?.forEach((job: any) => {
            jobListId.push(job.id)
        });

        let currGroup: any = [{ 'name': currGroupName[0].name, 'description': currGroupName[0].description, 'color': currValueColor, 'job': jobsSelected, 'groupType': groupTypeId }];

        if (groupsList.length > 0 || currGroupName.length != 0) {
            if (groupsList.some((e: any) => e.name === currGroupName[0].name) || currGroupName[0].name == '' || currGroupName.length == 0) {
                
            } else {
                setGroupsList([...groupsList, currGroup[0]]);
            }

        } else {
            setGroupsList([...groupsList, currGroupName]);
            return;
        }

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            const params = {
                name: currGroup[0].name,
                color: currGroup[0].color,
                description: currGroup[0].description,
                groupType: groupTypeId != '' ? groupTypeId : 0,
                jobs: jobListId
            };
            try {
                await axios.post(`${SERVER_URL}/group`, params, { headers })
                setGroupName('')
                handleChangeGroupName({ target: { value: '' } })
                setGroupDescription('')
                handleChangeGroupDescription({ target: { value: '' } })
                handleChangeColor({ value: '#ffffff' })
                setValueColor('#ffffff')
                jobsList.forEach((job: any) => {
                    job.checked = false
                })
                setJobsSelected([])
                handleChangeGroupType({ target: { value: '' } })
                getGroupList(true, true);
            } catch (error: any) {
                setError(error);
                if (error) {
                    setTimeout(() => {
                        setError(false);
                    }, 3000);
                }
                setLoading(false)
            }
        }

        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken)
            })
        }

        setMessageSavedGroup(true);
        if (!messageSavedGroup) {
            setTimeout(() => {
                setMessageSavedGroup(false);
            }, 3000);
        }
    }
    
    const cloneGroup = async (groupInfo: any) => {

        setLoading(true);

        let jobListId: any = []
        jobsSelected?.forEach((job: any) => {
            jobListId.push(job.id)
        });

        let currGroup: any = [{ 'name': groupInfo.name, 'description': groupInfo.description, 'color': groupInfo.color, 'job': jobsSelected, 'groupType': groupTypeId }];

        if (groupsList.length > 0 || groupInfo.name.length != 0) {
            if (groupsList.some((e: any) => e.name === groupInfo.name) || groupInfo.name == '' || groupInfo.name.length == 0) {
                
            } else {
                setGroupsList([...groupsList, currGroup[0]]);
            }

        } else {
            setGroupsList([...groupsList, groupInfo.name]);
            return;
        }

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            const params = {
                name: currGroup[0].name,
                color: currGroup[0].color,
                description: currGroup[0].description,
                groupType: groupTypeId != '' ? groupTypeId : 0,
                jobs: jobListId
            };
            try {
                await axios.post(`${SERVER_URL}/group`, params, { headers })
                setGroupName('')
                handleChangeGroupName({ target: { value: '' } })
                setGroupDescription('')
                handleChangeGroupDescription({ target: { value: '' } })
                handleChangeColor({ value: '' })
                jobsList.forEach((job: any) => {
                    job.checked = false
                })
                setJobsSelected([])
                handleChangeGroupType({ target: { value: '' } })
                getGroupList(true, true);
                setMessageClonedGroup(true);
            } catch (error: any) {
                setError(error);
                if (error) {
                    setTimeout(() => {
                        setError(false);
                    }, 3000);
                }
                setLoading(false)
            }
        }

        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken)
            })
        }

        if (!messageClonedGroup) {
            setTimeout(() => {
                setMessageClonedGroup(false);
            }, 3000);
        }
    }

    const removeNewGroup = async (groupId: any, index: any) => {

        setLoading(true);
        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            try {
                await axios.delete(`${SERVER_URL}/group/${groupId}`, { headers }),
                    setGroupsList((oldValues: any) => {
                        return oldValues.filter((_: any, i: any) => i !== index)
                    })
                handleChangeGroupName({ target: { value: '' } })
                handleChangeGroupDescription({ target: { value: '' } })
                handleChangeColor({ value: '' })
                setLoading(false)
                setMessageDeletedGroup(true)
            } catch (error: any) {
                setError(true);
                if (!error) {
                    setTimeout(() => {
                        setError(false);
                    }, 3000);
                }
                setLoading(false)
            }
        }

        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken)
            })
        }

        if (!messageDeletedGroup || !error) {
            setTimeout(() => {
                setMessageDeletedGroup(false);
                setError(false);
            }, 3000);
        }
    }

    const refreshGroup = () => {
        setGroupName('')
        handleChangeGroupName({ target: { value: '' } })
        setGroupDescription('')
        handleChangeGroupDescription({ target: { value: '' } })        
        jobsList.forEach((job: any) => {
            job.checked = false
        })
        setJobsSelected([])
        handleChangeGroupType({ target: { value: '' } })
        handleChangeColor({ value: '#ffffff' })
        setValueColor('#ffffff')
    }

    return (
        <div className="flex-parent-element" style={{ overflowX: 'hidden' }}>

            {/*{groupsList.length == 0 && loadingPanel && loading}*/}
            {loading && loadingPanel}

            <NotificationGroup
                style={{
                    right: 0,
                    bottom: 0,
                    position: "absolute",
                    alignItems: "flex-start",
                    flexWrap: "wrap-reverse",
                }}
            >
                <Fade enter={true} exit={true}>
                    {messageDeletedGroup && (
                        <Notification
                            type={{ style: "success", icon: true }}
                            //closable={true}
                            onClose={() => setMessageDeletedGroup(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.registry.group_deleted', 'NOT FOUND')}</span>
                        </Notification>
                    )}
                    {messageSavedGroup && (
                        <Notification
                            type={{ style: "success", icon: true }}
                            //closable={true}
                            onClose={() => setMessageSavedGroup(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.registry.group_saved', 'NOT FOUND')}</span>
                        </Notification>
                    )}
                    {messageClonedGroup && (
                        <Notification
                            type={{ style: "success", icon: true }}
                            //closable={true}
                            onClose={() => setMessageClonedGroup(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.registry.group_cloned', 'NOT FOUND')}</span>
                        </Notification>
                    )}
                    {messageUpdatedGroup && (
                        <Notification
                            type={{ style: "success", icon: true }}
                            //closable={true}
                            onClose={() => setMessageUpdatedGroup(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.registry.group_updated', 'NOT FOUND')}</span>
                        </Notification>
                    )}
                    {error && (
                        <Notification
                            type={{ style: "error", icon: true }}
                            //closable={true}
                            onClose={() => setMessageSavedGroup(false)}
                        >
                            {
                                errorMessage
                                    ?
                                    <span>{errorMessage}</span>
                                    :
                                    <span>{localizationService.toLanguageString('configuration.registry.group_with_device_error', 'NOT FOUND')}</span>
                            }
                        </Notification>
                    )}
                </Fade>
            </NotificationGroup>

            <div
                style={{
                    display: 'inline-table',
                    padding: '20px',
                    borderRight: '1px solid #1A8894'
                }}
            >
                <div style={{ textAlign:'center', marginBottom:'20px' }}>

                    <p 
                        style={{ display:'inline-flex', textAlign: 'center', fontSize: '20px', color: '#1A8893' }}
                    >
                        {localizationService.toLanguageString('configuration.registry.groups', 'NOT_FOUND')} ({groupsList.length})
                    </p>

                    <Button
                        title={localizationService.toLanguageString('configuration.registry.group_new', 'NOT FOUND')}
                        themeColor={"primary"}
                        className="plusParam"
                        style={{
                            marginRight: '10px',
                            marginTop: '0px',
                        }}
                        onClick={refreshGroup}
                    >
                        <Avatar
                            className="plusParam"
                        >
                            <SvgIcon
                                icon={plusIcon}
                                style={{ margin: '8px' }}
                            />
                        </Avatar>
                    </Button>
                </div>

                <div 
                    className="k-listview-item row p-1 align-middle" 
                    style={{ 
                        marginLeft: '30px' 
                    }}
                >
                    {groupsList?.map((group: any, index: any) => {
                        return (
                            group.id != -1 && 
                            <div key={index}>

                                <div
                                    className="trash-icon"
                                    title={localizationService.toLanguageString('configuration.registry.group_delete', 'NOT_FOUND')} 
                                    style={{
                                        float: 'left',
                                        cursor: 'pointer',
                                        alignContent: 'center',
                                        marginRight: '10px'
                                    }}
                                    onClick={() => {
                                        setUpdateGroup(false)
                                        removeNewGroup(group.id, index)
                                    }}
                                >
                                    <Avatar 
                                        className="trash-icon"                                        
                                    >
                                        <SvgIcon 
                                            icon={trashIcon} 
                                            style={{ verticalAlign: 'baseline', margin: '10px' }} 
                                        />
                                    </Avatar>
                                </div>

                                <div
                                    className="trash-icon"
                                    style={{
                                        float: 'left',
                                        cursor: 'pointer',
                                        alignContent: 'center',
                                        marginRight: '10px'
                                    }}
                                    onClick={() => {
                                        setUpdateGroup(false)
                                        cloneGroup(group)
                                    }}                                       
                                    title={localizationService.toLanguageString('configuration.registry.group_clone', 'NOT FOUND')}
                                >
                                    <Avatar 
                                        className="trash-icon"
                                    >
                                        <SvgIcon 
                                            icon={copyIcon} 
                                            style={{ verticalAlign: 'baseline', margin: '10px' }} 
                                        />
                                    </Avatar>
                                </div>  

                                <div
                                    style={{ display: 'inline-flex' }}
                                    onClick={() => getSelectedGroup(group)}
                                >
                                    <p 
                                        style={{ 
                                            border: `1px solid ${ (group?.color == '#ffffff' || group?.color == '#NaN') ? 'black' : group?.color}`, 
                                            borderRadius: '30px', 
                                            width: '18px', 
                                            height: '18px', 
                                            marginTop: '10px',
                                            background: `${group?.color}` 
                                        }}
                                    ></p>
                                    <p
                                        className="card-block-registry-group"
                                        style={{
                                            cursor: 'pointer',
                                            marginLeft: '10px',
                                            padding: '7px'
                                        }}
                                    >
                                        {`${group?.id ?? ''}: ${group?.name}`}
                                    </p>
                                </div>
                            </div>
                        )
                    })}
                </div>
                
            </div>
           
            
            <div
                className="flex-right-child-element"
                style={{
                    width: "65%",
                    display: 'inline-table',
                    background: 'white'
                }}
            >
                
                <div style={{display:'inline-flex'}}>
                    <span
                        className="k-icon k-font-icon k-i-palette"
                        style={{
                            fontSize: 'x-large',
                            cursor: 'pointer',
                            background: `${valueColor}`,
                            border: '1px solid #bdc4cb',
                            borderRadius: '30px',
                            padding: '20px',
                            marginRight: '20px'
                        }}
                        onClick={showColorPicker}
                    />

                    {/*name*/}
                    <p style={{ fontSize: '16px', color: '#1A8893', margin: '10px' }}>{localizationService.toLanguageString('configuration.registry.group_name', 'NOT_FOUND')}</p>
                    <TextBox
                        style={{ width: "350px", marginRight: '20px', marginBottom: '10px' }}
                        value={groupName == '' ? groupName : groupInfo?.map((group: any) => {
                            return group.name
                        })}
                        onChange={handleChangeGroupName}
                        placeholder=''
                    />

                    {/*save / update*/}
                    {!updateGroup ?
                        <Button
                            title={localizationService.toLanguageString('configuration.registry.group_save', 'NOT FOUND')}
                            themeColor={"primary"}
                            className="saveParam"
                            disabled={groupName == '' ? true : false}
                            onClick={() => saveNewGroup(groupInfo, valueColor)}
                        >
                            <Avatar
                                className="saveParam"
                            >
                                <SvgIcon
                                    icon={saveIcon}
                                    style={{ margin: '8px' }}
                                />
                            </Avatar>
                        </Button>
                        :
                        <div>

                            <Button
                                title={localizationService.toLanguageString('configuration.registry.group_update', 'NOT FOUND')}
                                themeColor={"primary"}
                                className="saveParam"
                                onClick={() => updateSelectedGroup(groupInfo[0].id, groupInfo[0].name, groupInfo[0].description, valueColor == groupInfo[0].color ? groupInfo[0].color : valueColor, groupInfo[0].job, groupInfo[0].type)}
                            >
                                <Avatar
                                    className="saveParam"
                                >
                                    <SvgIcon
                                        icon={saveIcon}
                                        style={{ margin: '8px' }}
                                    />
                                </Avatar>
                            </Button>

                        </div>
                    }

                </div>

                <div style={{ display: 'inline-flex', marginLeft: '25px' }}>
                    {/*description*/}
                    <p style={{ fontSize: '16px', color: '#1A8893', margin: '10px' }}>{localizationService.toLanguageString('configuration.registry.group_description', 'NOT_FOUND')}</p>
                    <TextBox
                        style={{ width: "350px", marginRight: '20px' }}
                        value={groupDescription == "" ? groupDescription : groupInfo?.map((group: any) => {
                            return group.description
                        }) }
                        onChange={handleChangeGroupDescription}
                        placeholder=''
                    />
                </div>

                <div style={{ marginLeft: '25px' }}>
                    {/*jobsList*/}
                    <p style={{ fontSize: '16px', color: '#1A8893', margin: '10px' }}>{localizationService.toLanguageString('configuration.registry.group_assignable_jobs', 'NOT_FOUND')}</p>
                    {jobsList?.map((job: any, index: any) => {
                        return (
                            job.id != -1 && 
                            <Checkbox
                                key={index}
                                name={job?.name}
                                style={{ marginLeft: '30px' }}
                                value={job?.name ?? job}
                                checked={job?.checked}
                                onChange={(e: any) => handleChangeJob(e, job.id)}
                                label={job?.name ?? ''}
                            >
                                <label className="checkbox-label-beacon" style={{ background: job?.color }} />
                            </Checkbox>
                        );
                    })}
                </div>

                <div style={{ marginLeft: '25px' }}>
                    <p style={{ fontSize: '16px', color: '#1A8893', margin: '10px' }}>{localizationService.toLanguageString('configuration.registry.subscription_group_type', 'NOT FOUND')}</p>
                    <DropDownList
                        //defaultItem={localizationService.toLanguageString('configuration.registry.subscription_group_type', 'NOT FOUND')}
                        style={{
                            width: "170px",
                            marginLeft: '10px'
                        }}
                        data={groupsTypeList?.data.map((group: any) => {
                            return (
                                group.name
                            )
                        })}
                        value={groupTypeName != '' ? groupTypeName : groupsTypeList.data[0].name}
                        onChange={handleChangeGroupType}
                    />
                </div>

                {/*colorpicker*/}
                {
                    toggleColorPicker &&
                    <div style={{ marginLeft: '35px' }}>
                        <br />
                        <div
                            style={{
                                background: valueColor,
                            }}
                        >
                            <div className="kendoka" />
                        </div>
                        <div>
                            {/*<p>Choose color:</p>*/}
                            <FlatColorPicker
                                value={valueColor}
                                format="hex"
                                showButtons={false}
                                onChange={handleChangeColor}
                            />
                        </div>

                    </div>
                }

            </div>

        </div>
    );


};